import { CONFIG } from '../config';

/**
 * 게임 시간 스케일 관리 (슬로우 모션)
 */
export class TimeManager {
    private timeScale: number = 1.0;
    private targetTimeScale: number = 1.0;
    private slowMoTimer: number = 0;
    private slowMoDuration: number = 0;
    private isFadingIn: boolean = false;
    private isFadingOut: boolean = false;

    /**
     * 슬로우 모션 트리거
     */
    triggerSlowMo(duration?: number, scale?: number): void {
        this.slowMoDuration = duration ?? CONFIG.SLOWMO.DURATION;
        this.slowMoTimer = this.slowMoDuration;
        this.targetTimeScale = scale ?? CONFIG.SLOWMO.TIME_SCALE;
        this.isFadingIn = true;
        this.isFadingOut = false;
    }

    /**
     * 슬로우 모션 즉시 중지
     */
    stopSlowMo(): void {
        this.slowMoTimer = 0;
        this.targetTimeScale = 1.0;
        this.timeScale = 1.0;
        this.isFadingIn = false;
        this.isFadingOut = false;
    }

    /**
     * 업데이트 - 스케일된 deltaTime 반환
     */
    update(deltaTime: number): number {
        const fadeDuration = CONFIG.SLOWMO.FADE_DURATION;

        if (this.slowMoTimer > 0) {
            // 슬로우 모션 진행 중
            this.slowMoTimer -= deltaTime;

            if (this.isFadingIn) {
                // 페이드 인
                this.timeScale = Math.max(
                    this.targetTimeScale,
                    this.timeScale - (1.0 - this.targetTimeScale) * (deltaTime / fadeDuration)
                );
                if (this.timeScale <= this.targetTimeScale) {
                    this.timeScale = this.targetTimeScale;
                    this.isFadingIn = false;
                }
            }

            // 슬로우 모션 종료 시작
            if (this.slowMoTimer <= fadeDuration && !this.isFadingOut) {
                this.isFadingOut = true;
            }

            if (this.isFadingOut) {
                // 페이드 아웃
                this.timeScale = Math.min(
                    1.0,
                    this.timeScale + (1.0 - this.targetTimeScale) * (deltaTime / fadeDuration)
                );
            }
        } else {
            // 슬로우 모션 종료
            this.timeScale = 1.0;
            this.isFadingIn = false;
            this.isFadingOut = false;
        }

        return deltaTime * this.timeScale;
    }

    /**
     * 현재 시간 스케일 반환
     */
    getTimeScale(): number {
        return this.timeScale;
    }

    /**
     * 슬로우 모션 활성화 여부
     */
    isSlowMoActive(): boolean {
        return this.slowMoTimer > 0;
    }

    /**
     * 리셋
     */
    reset(): void {
        this.timeScale = 1.0;
        this.targetTimeScale = 1.0;
        this.slowMoTimer = 0;
        this.slowMoDuration = 0;
        this.isFadingIn = false;
        this.isFadingOut = false;
    }
}
